@for (field of fields(); track field.name) {
  <orbit-form-field
    [label]="field.label"
    [name]="field.name"
    [inputType]="field.type"
    [controller]="field.controller" />
}
